<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showSnackBar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">Item Added to Cart</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex lg10 xl10 text-left>
        <v-layout px-2 pt-4 wrap>
          <v-flex text-left>
            <span style="font-family:opensansextrabold;font-size:24px;color:#70BA70;">&#9675;</span>
            <span
              style="font-family:opensansextrabold;font-size:20px;color:#060606"
            >&nbsp;Best Sellers</span>
          </v-flex>
          <v-flex text-right>
            <router-link to="/BestSellers">
              <span style="font-family:poppinsregular;font-size:14px;color:#70BA70">View all</span>
            </router-link>
          </v-flex>
        </v-layout>
        <v-layout v-if="products.length>0" px-2 wrap justify-start>
          <v-flex py-2 xs6 sm4 md3 lg2 v-for="(item,i) in products" :key="i">
            <v-card tile flat>
              <router-link :to="'/'+item._id+'/'+item.productname" style="text-decoration:none">
                <v-layout wrap justify-center>
                  <v-flex xs4 md2 text-center>
                    <v-card v-if="item.discountpercentage" color="#F13F3F" flat>
                      <span
                        style="font-family:opensanssemibold;font-size:12px;color:white"
                      >{{item.discountpercentage}} %</span>
                    </v-card>
                    <v-card v-else flat>
                      <span style="font-size:1px;color:white">.</span>
                    </v-card>
                  </v-flex>
                  <v-flex></v-flex>
                  <v-flex xs12 text-center>
                    <v-img :src="baseURL+'/u/'+item.photos[0]" height="100px" contain>
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-flex>
                  <v-flex
                    @click="$router.push('/'+item._id+'/'+item.productname)"
                    xs10
                    text-center
                    style="cursor:pointer;height:50px"
                  >
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#2D2D2D"
                      v-if="item.productname.length>30"
                    >{{item.productname.slice(0,30)+'...'}}</span>
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#2D2D2D"
                      v-else
                    >{{item.productname}}</span>
                  </v-flex>
                  <v-flex xs6 text-right>
                    <span
                      style="font-family:opensanssemibold;font-size:14px;color:#2D2D2D"
                    >₹ {{item.price}} &nbsp;</span>
                  </v-flex>
                  <v-flex pl-2 xs6 text-left>
                    <span
                      v-if="item.price!=item.mrp"
                      style="font-family:opensanssemibold;font-size:12px;color:#C6C6C6"
                    >
                      <s>₹ {{item.mrp}}</s>
                    </span>
                  </v-flex>
                </v-layout>
              </router-link>
              <v-layout wrap justify-center>
                <v-flex xs12 text-center>
                  <v-btn
                    v-if="item.instock"
                    small
                    outlined
                    depressed
                    :ripple="true"
                    color="#dadada"
                    @click="addToCart(item._id)"
                  >
                    <v-icon style="font-size:14px;color:#393939">mdi-cart</v-icon>
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#393939;"
                      class="text-capitalize px-1"
                    >&nbsp;Add to Cart</span>
                  </v-btn>
                  <v-btn
                    v-if="!item.instock"
                    small
                    outlined
                    depressed
                    :ripple="false"
                    color="#d90429"
                  >
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#d90429;text-transform:none;"
                    >&nbsp;Out of Stock</span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-snackbar v-model="snackbar" bottom right>
                Added Successfully
                <template v-slot:action="{ attrs }">
                  <v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
                </template>
              </v-snackbar>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      showSnackBar: false,
      products: [],
      snackbar: false,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/product/bestseller",
        params: {
          // pincode: localStorage.getItem("pincode"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.products = response.data.data;
          var tempary = [];
          for (var i = 0; i < 6; i++) {
            var ty = this.products[i];
            tempary.push(ty);
          }
          this.products = tempary;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addToCart(productid) {
      if (!store.state.isLoggedIn) {
        this.$router.push("/Login");
      }
      var cart = {};
      cart["productid"] = productid;
      cart["quantity"] = 1;
      cart["update"] = true;
      axios({
        method: "POST",
        url: "/Cart/Addorupdate",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("changeCart", response.data.count);
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>